import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  DeleteOutlined,
  EditOutlined,
  CheckCircleTwoTone,
  MinusCircleTwoTone,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import DesignationApi from "../../common/Apis/DesignationApi";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const Designations = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Designation, setDesignation] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));



  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    DesignationApi.ListDesignation(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setDesignation(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    DesignationApi.ListDesignation(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setDesignation(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getDesignation = useCallback(() => {
    DesignationApi.ListDesignation(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setDesignation(response.payloadDto);
        setTotalElements(response.totalElements);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);
  useEffect(() => {
    getDesignation();
    PageLoading();
  }, [getDesignation, PageLoading]);

  const handleDeleteDesignations = (DesignationsID) => {
    DesignationApi.DeleteDesignations(DesignationsID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getDesignation();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  const [pageSize, setPageSize] = useState(10);

  const handleRemovefilterDesignations = (FilterDesignationIndex) => {
    const newfilterDesignation = [...filterDesignations];
    newfilterDesignation.splice(FilterDesignationIndex, 1);
    setFilterDesignations(newfilterDesignation);
    if (FilterDesignationIndex == 0) {
      getDesignation();
    }
  };
  const handleClear = () => {
    getDesignation();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterDesignations([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterDesignations, setFilterDesignations] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterDesignations = () => {
    setFilterDesignations([
      ...filterDesignations,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterDesignations
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=DESIGNATION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setDesignation(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (filterDesignationIndex, value) => {
    const newfilterDesignation = [...filterDesignations];
    newfilterDesignation[filterDesignationIndex].title = value;
    setFilterDesignations(newfilterDesignation);
  };
  const handleChangeAnswertype = (filterDesignationIndex, value) => {
    const newfilterDesignation = [...filterDesignations];
    newfilterDesignation[filterDesignationIndex].answerType = value;
    setFilterDesignations(newfilterDesignation);
  };

  const handleChangename = (filterDesignationIndex, value) => {
    const newfilterDesignation = [...filterDesignations];
    newfilterDesignation[filterDesignationIndex].name = value;
    setFilterDesignations(newfilterDesignation);
  };

  const paginatedData = Designation.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item.id} className="text-center">
          <td style={{ width: "15%" }} className="pt-3">
            {item?.code}
          </td>
          <td style={{ width: "15%" }} className="pt-3">
            {item?.description}
          </td>
          <td style={{ width: "15%" }} className="pt-3">
            {item?.designationCategory}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {!item?.parentDesignationId && (
              <CheckCircleTwoTone className="inforIcon" />
            )}
          </td>
          <td style={{ width: "18%" }} className="pt-3">
            {item?.institutionDTO?.institutionName}
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/designations/edit-designation?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_DESIGNATION'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Designations ?"
                okText="Yes"
                onConfirm={() => handleDeleteDesignations(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_DESIGNATION'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            {/* <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            /> */}
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_DESIGNATION'
              ) ? 'btn btn-primary btn-save m-0 my-4' : 'd-none'}
              href={"/masters/designations/add-designation"}
            >
              Add new
            </Button> */}
            <Button
              type="primary"
              onClick={() => {
                navigate("/masters/designations/add-designation");
              }}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_DESIGNATION'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add new designation
            </Button>
          </td>
        </tr>
      );
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterDesignations.map((input, filterDesignationIndex) => (
                    <div key={filterDesignationIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterDesignationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterDesignationIndex, value)
                              }
                              options={[
                                { value: "code", label: "Code" },
                                {
                                  value: "description",
                                  label: "Name",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item
                            name={`type${filterDesignationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterDesignationIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            name={`name${filterDesignationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterDesignationIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterDesignationIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterDesignations}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterDesignations(
                                      filterDesignationIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData.length > 0 && (
                  <div className="d-flex align-items-end">
                    <Button
                      className="btn btn-primary btn-save m-0 my-2"
                      href={"/masters/designations/add-designation"}
                    >
                      Add new
                    </Button>
                    <Button
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'ADD_DESIGNATION'
                      ) ? 'btn btn-primary btn-save m-0 my-2 mx-2' : 'd-none'}
                      href={"/masters/designations/hierarchy-table"}
                    >
                      Hierarchy Table
                    </Button>
                  </div>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Designation Name</th>
                  <th>Category</th>
                  <th>Root</th>
                  <th>Department</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
           {paginatedData.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={PaginatetotalPages}
            onPageChange={handlePageChange}
            maxVisiblePages={5}
            showPageInfo={true}
            totalItems={totalElements}
            pageSize={pageSize}
          />
        )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Designations;
